import HttpClientToken from '../../services/HttpClientToken';

import { ConsecutivoProps, defaultConsecutivo } from '../../interfaces/admin/ConsecutivoInterface';

export const Consecutivo = () => {

    return new Promise<ConsecutivoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Consecutivo/', token)
            .then( ({ data } : { data : ConsecutivoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarConsecutivo = ( params: ConsecutivoProps ) => {

    return new Promise<ConsecutivoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Consecutivo/Actualizar', params, token)
            .then( ({ data } : { data : ConsecutivoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultConsecutivo } );
            });

        }

    });

}

export const AgregarConsecutivo = ( params: ConsecutivoProps ) => {

    return new Promise<ConsecutivoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Consecutivo/Agregar', params, token)
            .then( ({ data } : { data : ConsecutivoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultConsecutivo } );
            });

        }

    });

}
